// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"6bbe7d28","453":"25a2e4e7","806":"b657d4dc"}[chunkId] + ".chunk.js";
};